const SAMAYAL_URL =
  "https://whiture.sgp1.cdn.digitaloceanspaces.com/samayal/images/";
const ARTICLE_URL =
  "https://whi-high.fra1.cdn.digitaloceanspaces.com/articles/ta/";
const PROMOTION_URL = "https://cdn.kadalpura.com/promo/";
const current = new Date();
export { SAMAYAL_URL, ARTICLE_URL, PROMOTION_URL,current };
